export const VoPKeys = {
  consentStatus: ['vopConsentStatus']
};
